import type { IFuelEconomySpecifications } from '@/interfaces/IFuelEconomySpecifications'
import type { IValueAndUnit } from '@/interfaces/IValueAndUnit'
import Base from '@/models/Base'
import ValueAndUnit from './ValueAndUnit'

class FuelEconomySpecifications extends Base implements IFuelEconomySpecifications {
  fuelType: string
  fuelTankCapacity: IValueAndUnit<number>
  averageOnHighway: IValueAndUnit<number>
  averageInCity: IValueAndUnit<number>
  overallAverage: IValueAndUnit<number>

  constructor(fuelEconomySpecifications?: any) {
    super(fuelEconomySpecifications)
    this.fuelType = fuelEconomySpecifications?.fuelType
    this.fuelTankCapacity = new ValueAndUnit(fuelEconomySpecifications?.fuelTankCapacity)
    this.averageOnHighway = new ValueAndUnit(fuelEconomySpecifications?.averageOnHighway)
    this.averageInCity = new ValueAndUnit(fuelEconomySpecifications?.averageInCity)
    this.overallAverage = new ValueAndUnit(fuelEconomySpecifications?.overallAverage)
  }
}

export default FuelEconomySpecifications
